module.exports = __webpack_public_path__ + "static/media/imagePagePlaceholderPaymentForm.6a5e54bf.png";